import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import PenggunaPekerjaanTagihanService from "../../../services/pengaturan/PenggunaPekerjaanTagihanService";
import {AUTH_TOKEN} from "../../../constants/AuthConstant";

export const getListPekerjaanTagihan = createAsyncThunk('penggunaPekerjaanTagihan/list', async (data, { rejectWithValue }) => {
    try {
        const response = await PenggunaPekerjaanTagihanService.list(localStorage.getItem(AUTH_TOKEN), data)
        return response
    } catch (err) {
        return rejectWithValue(err.response.data)
    }
})

export const penggunaPekerjaanTagihanSlice = createSlice({
    name: 'penggunaPekerjaanTagihan',
    initialState: {
        loading: false,
        data_pekerjaan: [],
        data_tagihan: [],
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getListPekerjaanTagihan.pending, (state) => {
                state.loading = true
            })
            .addCase(getListPekerjaanTagihan.fulfilled, (state, action) => {
                state.loading = false
                if (action.meta.arg.type === 'pekerjaan') {
                    state.data_pekerjaan = action.payload.data
                } else {
                    state.data_tagihan = action.payload.data
                }
            })
            .addCase(getListPekerjaanTagihan.rejected, (state) => {
                state.loading = false
            })
    },
})

export default penggunaPekerjaanTagihanSlice.reducer
